export default __webpack_public_path__ + "static/media/CirclePerson.d90ed058.png";